import React, { useEffect, useState } from 'react';
import SftGlobalData from '../../library/SftGlobalData';
import axios from 'axios';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import { Box, Button, TextField, Tab, Tabs, Modal, Switch, IconButton, Card, CardContent, Typography, Collapse } from '@mui/material';
import { faPencilAlt, faImage, faVideo, faTrash, faTimes } from '@fortawesome/free-solid-svg-icons';
import Colors from '../../library/Colors';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FloatingAddButton from '../../components/FloatingAddButton';
import CustomerDisplayModal from '../customerDisplay/CustomerDisplayModal';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import { TailSpin } from 'react-loader-spinner'
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import FloatingSaveButton from '../../components/FloatingSaveButton';
import ConfigurationProcessor from '../customerDisplay/ConfigurationProcessor';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
};

const VIDEO_EXTENSIONS = ['mp4', 'webm', 'ogg', 'mov'];
const isVideoFile = (filename) => {
    if (!filename) return false;
    const ext = filename.split('.').pop().toLowerCase();
    return VIDEO_EXTENSIONS.includes(ext);
};

const CustomerDisplayScreen = (props) => {
    const [value, setValue] = useState(0);
    const [customerDisplays, setCustomerDisplays] = useState([]);
    const [loading, setLoading] = useState(true);
    const [ftp, setFtp] = useState({ host: "", path: "", port: "", username: "", password: "", url: "" });
    const [customerDisplayHeaderText, setCustomerDisplayHeaderText] = useState("");
    const [defaultDuration, setDefaultDuration] = useState(0);
    const [storeScreenTypes, setStoreScreenTypes] = useState([]);
    const [sameSettingAllStores, setSameSettingsAllStores] = useState(true);
    const [availableStores, setAvailableStores] = useState("");
    const [availablePos, setAvailablePos] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [modalEditData, setModalEditData] = useState({});
    const [dbVersion, setDbVersion] = useState(0);
    const [selectedImage, setSelectedImage] = useState(null);
    const initialGrid = getCookie("initialStateTemplate") === "{}" ? { columns: { columnVisibilityModel: { id: false }, } } : JSON.parse(getCookie("intialCustomerDisplayState"));
    const [showPreview, setShowPreview] = useState(false);

    // Expanded states for color sections
    const [backgroundColorsExpanded, setBackgroundColorsExpanded] = useState(false);
    const [textColorsExpanded, setTextColorsExpanded] = useState(false);
    const [storeExpandedStates, setStoreExpandedStates] = useState({});

    // Helper functions to manage individual store states
    const setStoreBackgroundColorsExpanded = (storeCode, expanded) => {
        setStoreExpandedStates(prev => ({
            ...prev,
            [storeCode]: {
                ...prev[storeCode],
                backgroundExpanded: expanded
            }
        }));
    };

    const setStoreTextColorsExpanded = (storeCode, expanded) => {
        setStoreExpandedStates(prev => ({
            ...prev,
            [storeCode]: {
                ...prev[storeCode],
                textExpanded: expanded
            }
        }));
    };

    // Get expanded states for a specific store
    const getStoreExpandedState = (storeCode) => {
        return storeExpandedStates[storeCode] || { 
            backgroundExpanded: false, 
            textExpanded: false 
        };
    };

    // Color and display settings state - using ConfigurationProcessor defaults
    const [generalStoreImageSplit, setGeneralStoreImageSplit] = useState(false);
    const [generalColors, setGeneralColors] = useState(ConfigurationProcessor.DEFAULT_COLORS);
    const [storeColors, setStoreColors] = useState([]);

    const apiRef = useGridApiRef();

    const gridColumns = [
        {
            field: 'id',
            headerName: 'Id',
            minWidth: 120,
            align: "left",
            flex: 1
        },
        {
            field: 'title',
            headerName: 'Title',
            minWidth: 120,
            align: "left",
            flex: 1,
        },
        {
            field: 'store_ids',
            headerName: 'Store',
            minWidth: 60,
            align: "left",
            flex: 1,
        },
        {
            field: 'pos_ids',
            headerName: 'Pos',
            minWidth: 60,
            align: "left",
            flex: 1,
        },
        {
            field: 'edit',
            headerName: 'edit',
            flex: 1,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                return <Button style={{ color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height: "100%", borderRadius: "50%" }} onClick={() => { editRow(params.row.id) }} >
                    <FontAwesomeIcon icon={faPencilAlt} color={Colors.def_orange} size="2x" />
                </Button>;
            }
        },
        {
            field: 'vb',
            headerName: 'vb',
            flex: 1,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                const display = customerDisplays.find(d => d.id === params.row.id);
                return (
                <ImagePreviewTooltip id={params.row.id}>
                    <Button
                        style={{
                            color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text),
                            height: "100%",
                            borderRadius: "50%"
                        }}
                        onClick={() => showImage(params.row.id)}
                    >
                        <FontAwesomeIcon icon={isVideoFile(display?.filename) ? faVideo : faImage} color={Colors.def_grey} size="2x" />
                    </Button>
                </ImagePreviewTooltip>
            );
            }
        },
        {
            field: 'delete',
            headerName: 'delete',
            flex: 1,
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                return <Button style={{ color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height: "100%", borderRadius: "50%" }} onClick={() => { if(SftGlobalData.confirmWindow(props.t('delete_confirmation'))){ onDeleteCustomerDisplay(params.row.id)} }} >
                    <FontAwesomeIcon icon={faTrash} color={Colors.def_red} size="2x" />
                </Button>;
            }
        },
        {
            field: 'display_from',
            headerName: 'From',
            minWidth: 120,
            align: "left",
            flex: 1,
        },
        {
            field: 'display_until',
            headerName: 'Until & with',
            minWidth: 120,
            align: "left",
            flex: 1,
        },
        {
            field: 'display_type',
            headerName: 'Type',
            minWidth: 120,
            align: "left",
            flex: 1,
        },
        {
            field: 'duration',
            headerName: 'Duration',
            minWidth: 120,
            align: "left",
            flex: 1,
        },
        {
            field: 'sort',
            headerName: 'Sort',
            minWidth: 120,
            align: "left",
            flex: 1,
        }
    ];

    const ImagePreviewTooltip = ({ id, children }) => {
        const customerDisplay = customerDisplays.find((display) => display.id === id);

        if (!customerDisplay) return children;

        // Build the image URL once
        let fullImageUrl = ftp.url;

        // Make sure the URL has the proper protocol
        if (!fullImageUrl.startsWith('http://') && !fullImageUrl.startsWith('https://')) {
            fullImageUrl = 'https://' + fullImageUrl;
        }

        // Ensure URL ends with a slash if needed
        if (!fullImageUrl.endsWith('/')) {
            fullImageUrl += '/';
        }

        // Append the filename with proper encoding
        fullImageUrl += encodeURIComponent(customerDisplay.filename);

        return (
            <Tooltip
                title={
                    <div style={{ maxWidth: '200px', maxHeight: '200px' }}>
                        {isVideoFile(customerDisplay.filename) ? (
                            <video
                                src={fullImageUrl}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: '200px',
                                    objectFit: 'contain'
                                }}
                                muted
                                autoPlay
                                loop
                            />
                        ) : (
                            <img
                                src={fullImageUrl}
                                alt="Preview"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: '200px',
                                    objectFit: 'contain'
                                }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = 'path/to/fallback-image.png';
                                }}
                            />
                        )}
                    </div>
                }
                arrow
                placement="right"
                TransitionComponent={Zoom}
            >
                {children}
            </Tooltip>
        );
    };

    /**
     * Opens the edit modal for the customer display with the given id.
     * @param {number} id The id of the customer display to edit.
     */
    const editRow = (id) => {
        const customerDisplay = customerDisplays.find((customerDisplay) => customerDisplay.id === id);
        setModalEditData(customerDisplay);
        setModalContent("edit");
        setModalOpen(true);
    }

    const createRow = () => {
        setModalContent("create");
        setModalOpen(true);
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "{}";
    }

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    const visibilityChangedHandler = () => {
        let temp = apiRef.current.exportState();
        if (typeof temp.columns.columnVisibilityModel === "undefined") {
            temp.columns.columnVisibilityModel = {};
        }
        try {
            temp.preferencePanel.open = false;
        } catch (e) {
            // Handle error silently
        }
        try {
            delete temp.pagination;
        } catch (e) {
            console.error(e);
        }
        setCookie("intialCustomerDisplayState", JSON.stringify(temp), 100000);
    }

    const onDeleteCustomerDisplay = (id) => {
        SftGlobalData.post('sftData&action=deleteCustomerDisplay', { key: props.api, data: id }).then(response => {
            setLoading(true);
            loadData(); // Reload data to reflect the deletion
        }).catch(error => {
            console.error('Error deleting display:', error);
        });
    }

    const fetchDbVersion = () => {
        SftGlobalData.post('sftData', { key: props.api, type: "dbversion" }).then(response => {
            setDbVersion(parseInt(response.data.version));
        }); 
    }

    useEffect(() => {
        props.changeScreen('Licence');
        if (props.api) {
            setLoading(true);
            fetchDbVersion();
            loadData();
        }
    }, [props.api]);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };

    const loadData = () => {
        console.log("Loading customer display data...");
        
        // Load stores
        SftGlobalData.post('sftData', { key: props.api, type: "stores" }).then(response => {
            setAvailableStores(response.data);
        });

        // Load POS systems
        SftGlobalData.post('sftData', { key: props.api, type: "pos" }).then(response => {
            setAvailablePos(response.data);
        });
        SftGlobalData.post('sftData', {
            key: props.api, 
            type: "kasvars",
            code: ConfigurationProcessor.getSupportedConfigCodes()
        }).then(response => {
            // Process configuration using ConfigurationProcessor
            const configResult = ConfigurationProcessor.processConfiguration(
                response.data,
                {
                    setCustomerDisplayHeaderText,
                    setGeneralStoreImageSplit,
                    setSameSettingsAllStores,
                }
            );

            // Update all state at once for better performance
            setFtp(configResult.ftp);
            setDefaultDuration(configResult.defaultDuration);
            setStoreScreenTypes(configResult.storeScreenTypes);
            setGeneralColors(configResult.generalColors);
            setStoreColors(configResult.storeColors);
            
        }).catch(error => {
            if (SftGlobalData.debug) {
                console.log('Configuration loading error:', error);
            }
        });

        // Load customer displays
        SftGlobalData.post('sftData&action=getCustomerDisplays', { key: props.api }).then(response => {
            setCustomerDisplays(response.data);
            setLoading(false);
        });
    };

    const handleFtpEdit = (value, field) => {
        let ftpObj = { ...ftp };
        switch (field) {
            case 'url':
                ftpObj.url = value;
                break;
            case 'path':
                ftpObj.path = value;
                break;
            case 'host':
                ftpObj.host = value;
                break;
            case 'port':
                ftpObj.port = value;
                break;
            case 'username':
                ftpObj.username = value;
                break;
            case 'password':
                ftpObj.password = value;
                break;
            default:
                break;
        }
        setFtp(ftpObj);
    }

    // Improved handler for screen type changes
    const handleScreenTypeChange = (storeId, isSplitScreen) => {
        setStoreScreenTypes(prevTypes => {
            // Make a copy of the current state
            const updatedTypes = [...prevTypes];

            // Find if this store already has settings
            const existingIndex = updatedTypes.findIndex(item => item.id === storeId);

            if (existingIndex >= 0) {
                // Update existing setting
                updatedTypes[existingIndex] = {
                    ...updatedTypes[existingIndex],
                    isSplitScreen: isSplitScreen
                };
            } else {
                // Add new setting
                updatedTypes.push({
                    id: storeId,
                    isSplitScreen: isSplitScreen
                });
            }
            return updatedTypes;
        });
    };

    // Color handling functions
    const handleGeneralColorChange = (colorType, value) => {
        setGeneralColors(prev => ({
            ...prev,
            [colorType]: value
        }));
    };

    const handleStoreColorChange = (storeId, colorType, value) => {
        setStoreColors(prev => {
            const updated = [...prev];
            const existingIndex = updated.findIndex(item => item.storeId === storeId);

            if (existingIndex >= 0) {
                updated[existingIndex] = {
                    ...updated[existingIndex],
                    [colorType]: value
                };
            } else {
                updated.push({
                    storeId: storeId,
                    // Background colors
                    mainBackgroundColor: colorType === 'mainBackgroundColor' ? value : generalColors.mainBackgroundColor,
                    headerBackgroundColor: colorType === 'headerBackgroundColor' ? value : generalColors.headerBackgroundColor,
                    customerHeaderBackgroundColor: colorType === 'customerHeaderBackgroundColor' ? value : generalColors.customerHeaderBackgroundColor,
                    itemRowBackgroundColor: colorType === 'itemRowBackgroundColor' ? value : generalColors.itemRowBackgroundColor,
                    totalSectionBackgroundColor: colorType === 'totalSectionBackgroundColor' ? value : generalColors.totalSectionBackgroundColor,
                    sftFooterBackgroundColor: colorType === 'sftFooterBackgroundColor' ? value : generalColors.sftFooterBackgroundColor,

                    // Text colors
                    headerTextColor: colorType === 'headerTextColor' ? value : generalColors.headerTextColor,
                    customerHeaderTextColor: colorType === 'customerHeaderTextColor' ? value : generalColors.customerHeaderTextColor,
                    itemTextColor: colorType === 'itemTextColor' ? value : generalColors.itemTextColor,
                    // priceTextColor: colorType === 'priceTextColor' ? value : generalColors.priceTextColor,
                    totalTextColor: colorType === 'totalTextColor' ? value : generalColors.totalTextColor,
                    totalSubTextColor: colorType === 'totalSubTextColor' ? value : generalColors.totalSubTextColor,
                    sftFooterTextColor: colorType === 'sftFooterTextColor' ? value : generalColors.sftFooterTextColor,

                    // Accent colors
                    primaryAccentColor: colorType === 'primaryAccentColor' ? value : generalColors.primaryAccentColor,
                    secondaryAccentColor: colorType === 'secondaryAccentColor' ? value : generalColors.secondaryAccentColor,
                    highlightColor: colorType === 'highlightColor' ? value : generalColors.highlightColor,

                    // Border colors
                    borderColor: colorType === 'borderColor' ? value : generalColors.borderColor,
                    separatorColor: colorType === 'separatorColor' ? value : generalColors.separatorColor
                });
            }
            return updated;
        });
    };

    const getStoreColors = (storeId) => {
        const storeColor = storeColors.find(item => item.storeId === storeId);
        return storeColor || {
            // Background colors
            mainBackgroundColor: generalColors.mainBackgroundColor,
            headerBackgroundColor: generalColors.headerBackgroundColor,
            customerHeaderBackgroundColor: generalColors.customerHeaderBackgroundColor,
            itemRowBackgroundColor: generalColors.itemRowBackgroundColor,
            totalSectionBackgroundColor: generalColors.totalSectionBackgroundColor,
            sftFooterTextColor: generalColors.sftFooterTextColor,

            // Text colors
            headerTextColor: generalColors.headerTextColor,
            customerHeaderTextColor: generalColors.customerHeaderTextColor,
            itemTextColor: generalColors.itemTextColor,
            // priceTextColor: generalColors.priceTextColor,
            totalTextColor: generalColors.totalTextColor,
            totalSubTextColor: generalColors.totalSubTextColor,
            sftFooterTextColor: generalColors.sftFooterTextColor,

            // Accent colors
            primaryAccentColor: generalColors.primaryAccentColor,
            secondaryAccentColor: generalColors.secondaryAccentColor,
            highlightColor: generalColors.highlightColor,

            // Border colors
            borderColor: generalColors.borderColor,
            separatorColor: generalColors.separatorColor
        };
    };

    // 3. Add a handler for saving the form data
    const handleSaveDisplay = (formData) => {
        let imageBase64 = formData.imageBase64;
        let imageFileName = formData.filename;
        let formDataWithoutImage = { ...formData };
        delete formDataWithoutImage.imageBase64;

        SftGlobalData.post('sftData&action=createOrUpdateCustomerDisplay', { key: props.api, data: formDataWithoutImage }).then(response => {
            // Handle success
            setModalOpen(false);
            if (imageBase64) {
                //now we need to upload the image to ftp
                SftGlobalData.post('sftData&action=uploadFile', { key: props.api, data: { imageBase64, imageFileName } }).then(response => {
                    setLoading(true);
                    loadData(); // Reload data to show the new entry
                })
            } else {
                setLoading(true);
                loadData(); // Reload data to show the new entry
            }
        }).catch(error => {
            // Handle error
            if (SftGlobalData.debug) {
                console.log('Error saving display:', error);
            }

        });

        // For now, just close the modal
        setModalOpen(false);
    };

    const showImage = (id) => {
        const customerDisplay = customerDisplays.find((customerDisplay) => customerDisplay.id === id);

        if (customerDisplay) {
            // Ensure we have a properly formatted absolute URL
            let fullImageUrl = ftp.url;

            // Make sure the URL has the proper protocol
            if (!fullImageUrl.startsWith('http://') && !fullImageUrl.startsWith('https://')) {
                fullImageUrl = 'https://' + fullImageUrl; // Or 'http://' depending on your server
            }

            // Ensure URL ends with a slash if needed
            if (!fullImageUrl.endsWith('/')) {
                fullImageUrl += '/';
            }

            // Append the filename with proper encoding
            fullImageUrl += encodeURIComponent(customerDisplay.filename);

            console.log('Full image URL:', fullImageUrl); // For debugging

            setSelectedImage({
                ...customerDisplay,
                fullImageUrl: fullImageUrl
            });

            setShowPreview(true);
        }
    };

    const handleSaveSettings = (tabValue) => {
        if(tabValue == 1){
            saveColors();
        }
        if(tabValue == 2){
            saveSettings();
        }
    }

    const saveSettings = () => {
        setModalOpen(false);
        SftGlobalData.post('sftData&action=updateKasvar', {
            key: props.api, data: [
                { var: "CustomerDisplayFTPHost", value: ftp.host, varType: "Text", minValue: 0, maxValue: 1, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY FTP HOST" },
                { var: "CustomerDisplayFTPUser", value: ftp.username, varType: "Text", minValue: 0, maxValue: 1, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY FTP USER" },
                { var: "CustomerDisplayFTPPass", value: ftp.password, varType: "Text", minValue: 0, maxValue: 1, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY FTP PASS" },
                { var: "CustomerDisplayFTPPath", value: ftp.path, varType: "Text", minValue: 0, maxValue: 1, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY FTP PATH" },
                { var: "CustomerDisplayFTPPort", value: ftp.port, varType: "Integer", minValue: 0, maxValue: 99999, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY FTP PORT" },
                { var: "CustomerDisplayURL", value: ftp.url, varType: "Text", minValue: 0, maxValue: 1, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY FTP URL" },
                { var: "CustomerDisplayDefaultDuration", value: defaultDuration, varType: "Integer", minValue: 0, maxValue: 1, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY DEFAULT DURATION" },
                { var: "CustomerDisplayGeneralColors", value: JSON.stringify(generalColors), varType: "Text", minValue: 0, maxValue: 1, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY GENERAL COLORS" },
                { var: "CustomerDisplayStoreColors", value: JSON.stringify(storeColors), varType: "Text", minValue: 0, maxValue: 1, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY STORE COLORS" },
            ]
        }).then(response => {
            // Handle success
            console.log(` response: fileUpload`, response);
            loadData(); // Reload data to show the new entry
        }).catch(error => {
            // Handle error
            console.error('Error saving display:', error);
        });
    }

    const saveColors = () => {
        setModalOpen(false);
        let sftKasvarBaseSettings = [
            { var: "CustomerDisplayHeadercolor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE HEADER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplayHeaderTextcolor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE TEXT IN THE HEADER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplayHeaderCustomercolor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE CUSTOMER HEADER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplayHeaderCustomerTextcolor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE TEXT IN THE CUSTOMER HEADER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplayHeaderCustomerTextcolor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE TEXT IN THE CUSTOMER HEADER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplayHeaderCustomerTextcolor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE TEXT IN THE CUSTOMER HEADER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplaySalesRowColor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE TEXT IN THE SALES ROW (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplaySalesRowTextColor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE TEXT IN THE ROWS IN THE SALES SCREEN (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplayFootercolor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE FOOTER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplayFooterTextcolor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE TEXT IN THE FOOTER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplayFooterTextcolor2", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE TEXT WITH PIECES BOUGHT IN THE FOOTER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplaySoftTouchcolor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE SOFTTOUCH FOOTER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplaySoftTouchTextcolor", varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "THE COLOR OF THE TEXT IN THE SOFTTOUCH FOOTER (CUSTOMERDISPLAY)" },
            { var: "CustomerDisplaySplitSalesScreen", varType: "Boolean", minValue: 'T', maxValue: 'F', varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY SPLIT SALES SCREEN" },
            { var: "CustomerDisplaySameSettingsAllStores", varType: "Boolean", minValue: 'T', maxValue: 'F', varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY SPLIT SALES SCREEN" },
            
            // { var: "CHECK", value: sameSettingAllStores ? 'T' : 'F', varType: "Boolean", minValue: 'T', maxValue: 'F', varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY SPLIT SALES SCREEN" },

        ];

        let postData = [
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayHeadercolor"), value : generalColors.headerBackgroundColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayHeaderTextcolor"), value : generalColors.headerTextColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayHeaderCustomercolor"), value : generalColors.customerHeaderBackgroundColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayHeaderCustomerTextcolor"), value : generalColors.customerHeaderTextColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplaySalesRowColor"), value : generalColors.itemRowBackgroundColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplaySalesRowTextColor"), value : generalColors.itemTextColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayFootercolor"), value : generalColors.totalSectionBackgroundColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayFooterTextcolor"), value : generalColors.totalTextColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayFooterTextcolor2"), value : generalColors.totalSubTextColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplaySoftTouchcolor"), value : generalColors.sftFooterBackgroundColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplaySoftTouchTextcolor"), value : generalColors.sftFooterTextColor},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplaySplitSalesScreen"), value : generalStoreImageSplit ? 'T' : 'F'},
                {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplaySameSettingsAllStores"), value : sameSettingAllStores ? 'T' : 'F'},
                // { var: "CustomerDisplayFooterCardcolor", value: generalColors.totalSectionBackgroundColor, varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY SPLIT SALES SCREEN PER STORE" },
                // { var: "CustomerDisplayFooterCardTextcolor", value: JSON.stringify(storeScreenTypes), varType: "Integer", minValue: 0, maxValue: 100000000, varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY SPLIT SALES SCREEN PER STORE" },
        ];

        if (!sameSettingAllStores) {
            let differentStoreColors = [];
            for (let i = 0; i < storeColors.length; i++) {
                if (storeColors[i] !== generalColors) {
                    differentStoreColors.push(storeColors[i]);
                }
            }
            differentStoreColors.map((differentStoreColor, i) => {
                let storeId = differentStoreColor.storeId;
                let splitscreen = storeScreenTypes.find((s) => s.id === storeId)?.isSplitScreen ? 'T' : 'F';
                postData.push(
                    { var: "CustomerDisplaySplitSalesScreen", value: splitscreen, varType: "Boolean", minValue: 'T', maxValue: 'F', varMainGroup: "SALES", varGroup: "CUSTOMER DISPLAY", description: "CUSTOMER DISPLAY SPLIT SALES SCREEN", code:2, group: `00${storeId}` },
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayHeadercolor"), value : differentStoreColor.customerHeaderBackgroundColor, code:2, group: `00${storeId}`},
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayHeaderTextcolor"), value : differentStoreColor.customerHeaderTextColor, code:2, group: `00${storeId}`},
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayHeaderCustomercolor"), value : differentStoreColor.customerHeaderBackgroundColor, code:2, group: `00${storeId}`},
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayHeaderCustomerTextcolor"), value : differentStoreColor.customerHeaderTextColor, code:2, group: `00${storeId}`},
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayFootercolor"), value : differentStoreColor.totalSectionBackgroundColor, code:2, group: `00${storeId}`},
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayFooterTextcolor"), value : differentStoreColor.totalTextColor, code:2, group: `00${storeId}`},
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplayFooterTextcolor2"), value : differentStoreColor.totalSubTextColor, code:2, group: `00${storeId}`},
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplaySalesRowColor"), value : differentStoreColor.totalSectionBackgroundColor, code:2, group: `00${storeId}`},
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplaySalesRowTextColor"), value : differentStoreColor.totalTextColor, code:2, group: `00${storeId}`},
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplaySoftTouchcolor"), value : differentStoreColor.sftFooterBackgroundColor, code:2, group: `00${storeId}`},
                    {...sftKasvarBaseSettings.find(item => item.var === "CustomerDisplaySoftTouchTextcolor"), value : differentStoreColor.sftFooterTextColor, code:2, group: `00${storeId}`},
                );
            });
        }

        SftGlobalData.post('sftData&action=updateKasvar', { key: props.api, type: "kasvars", data: postData }).then(response => {
            console.log(` response: updateKasvar`, response);
            loadData(); // Reload data to show the new entry
        }).catch(error => {
            // Handle error
            console.error('Error updating kasvars:', error);
        });
    }

    const hexChecker = (hex) => {
        const hexPattern = /^#[0-9A-Fa-f]{6}$/;
        if (!hexPattern.test(hex)) {
            // Handle invalid hex value
            console.warn('Invalid hex color format');
        }
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }} className={(props.screenWidth) < 600 ? 'not_expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme : 'expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme} >
            <CustomerDisplayModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                screenWidth={props.screenWidth}
                theme={props.theme}
                t={props.t}
                stores={availableStores || []}
                posList={availablePos || []}
                onSave={handleSaveDisplay}
                defaultDuration={defaultDuration}
                modalContent={modalContent}
                modalData={modalEditData}
                imageBaseUrl={ftp.url}
            />

            <Modal
                open={showPreview}
                onClose={() => setShowPreview(false)}
                aria-labelledby="image-preview-modal"
                aria-describedby="preview of customer display image"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: 2,
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: 0,
                    overflow: 'hidden'
                }}>
                    {selectedImage && (
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            {/* Close button */}
                            <IconButton
                                onClick={() => setShowPreview(false)}
                                sx={{
                                    position: 'absolute',
                                    top: 10,
                                    right: 10,
                                    zIndex: 10,
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.7)'
                                    },
                                    width: 36,
                                    height: 36
                                }}
                                size="small"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </IconButton>

                            {/* Image / Video */}
                            {isVideoFile(selectedImage.filename) ? (
                                <video
                                    src={selectedImage.fullImageUrl}
                                    style={{
                                        maxWidth: '90vw',
                                        maxHeight: '90vh',
                                        objectFit: 'contain'
                                    }}
                                    controls
                                    autoPlay
                                    loop
                                />
                            ) : (
                                <img
                                    src={selectedImage.fullImageUrl}
                                    alt={`Preview for ${selectedImage.id}`}
                                    style={{
                                        maxWidth: '90vw',
                                        maxHeight: '90vh',
                                        objectFit: 'contain'
                                    }}
                                    onError={(e) => {
                                        console.error('Image failed to load:', selectedImage.fullImageUrl);
                                        e.target.onerror = null;
                                        e.target.src = 'path/to/fallback-image.png';
                                    }}
                                />
                            )}
                        </Box>
                    )}
                </Box>
            </Modal>
            <div className={"container_list__title " + props.theme}><h2>{props.t('customer_displays')}</h2></div>
            <div className='rowContainerCenter _100perc'>
                {(dbVersion >= 316) && <Box className={props.theme + ' _100perc'}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className={props.theme + ' container_tabs_below_subtitle'}>
                        <Tabs value={value} onChange={handleChangeTab} className={props.theme} variant="scrollable" scrollButtons="auto">
                            <Tab label={props.t('images_customer_display') + " "} {...a11yProps(0)} className={props.theme} />
                            <Tab label={props.t('colors_customer_display') + " "} {...a11yProps(2)} className={props.theme} />
                            {(props.login.sft_status != "0") ?<Tab label={props.t('general_settings_customer_display') + " "} {...a11yProps(1)} className={props.theme} /> : ""}
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                        <div className='rowContainerCenter _100perc'>
                            {loading && <div className={"container_list__title " + props.theme} style={{ display: "flex", justifyContent: "space-evenly", marginTop: 5, border: 1 }}>
                                <TailSpin
                                    height="40"
                                    width="40"
                                    color={Colors.sft_blue}
                                    ariaLabel='loading'
                                />
                            </div>}

                            {(!loading && typeof customerDisplays !== "undefined" && customerDisplays?.length > 0 && dbVersion >= 316) && <DataGridPro
                                apiRef={apiRef}
                                initialState={initialGrid}
                                className={'manuals_application_headers ' + props.theme}
                                columns={gridColumns}
                                rows={customerDisplays.map((row, index) => {
                                    return {
                                        id: row.id,
                                        sort: row.sort,
                                        title: row.title,
                                        store_ids: row.store_ids,
                                        pos_ids: row.pos_ids,
                                        edit: "Edit",
                                        example: "Example",
                                        delete: "Delete",
                                        display_from: row.display_from,
                                        display_until: row.display_until,
                                        display_type: row.display_type,
                                        duration: row.duration
                                    }
                                })}
                                onColumnWidthChange={() => { visibilityChangedHandler(); }}
                                onColumnVisibilityModelChange={() => { visibilityChangedHandler(); }}
                                onPreferencePanelClose={() => { visibilityChangedHandler(); }}
                                rowThreshold={0}
                                rowHeight={38}
                                height={300}
                                loading={loading}
                                pagination={false}
                            />}
                            {(!loading && (typeof customerDisplays === "undefined" || customerDisplays?.length === 0)) && props.login.sft_status != "0" && <h1>{props.t('no_customer_displays_found')}</h1>}
                        </div>
                    </TabPanel>
                                        {/* New Colors Tab */}
                    <TabPanel value={value} index={1}>
                        <div className='columnContainerStart _100perc'>
                            {/* General Colors Section */}
                            <Card style={{ marginBottom: '2rem', padding: '1rem' }}>
                                {/* Header with title and switch */}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '0.5rem'
                                }}>
                                    <h3 style={{ margin: 0, width: '70%' }}>{props.t('CustomerDisplayGeneral')}</h3>

                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.5rem'
                                    }}>
                                        <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                            {props.t('customer_display_split_screen')}
                                        </Typography>
                                        <Switch
                                            size="small"
                                            checked={generalStoreImageSplit}
                                            onChange={(e) => {
                                                setGeneralStoreImageSplit(!generalStoreImageSplit);
                                            }}
                                            inputProps={{ 'aria-label': 'fullscreen toggle' }}
                                        />
                                    </div>
                                </div>
                                <CardContent>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 3,
                                        position: 'relative',
                                        '& .color-section': {
                                            '& .section-header': {
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                cursor: 'pointer',
                                                padding: '0.5rem 0.5rem 0.1rem 0.5rem',
                                                borderRadius: '8px',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                }
                                            },
                                            '& .section-title': {
                                                fontSize: '1rem',
                                                fontWeight: 600,
                                                color: 'text.primary',
                                                borderBottom: '2px solid',
                                                borderColor: 'primary.main',
                                                display: 'inline-block',
                                                paddingBottom: '4px',
                                            },
                                            '& .expand-icon': {
                                                transition: 'transform 0.2s ease',
                                                color: 'primary.main',
                                            }
                                        },
                                        '& .color-grid': {
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                            gap: 1.5,
                                            marginTop: 2,
                                        },
                                        '& .color-input-group': {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            p: 1,
                                            borderRadius: 2,
                                            backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                            border: '1px solid rgba(0, 0, 0, 0.08)',
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                borderColor: 'rgba(0, 0, 0, 0.12)',
                                            }
                                        },
                                        '& .color-label': {
                                            minWidth: '50px',
                                            fontSize: '0.875rem',
                                            fontWeight: 500,
                                            color: 'text.primary',
                                            lineHeight: 1.2,
                                        },
                                        '& .color-input': {
                                            width: '44px',
                                            height: '34px',
                                            border: '2px solid rgba(0, 0, 0, 0.1)',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                borderColor: 'primary.main',
                                                transform: 'scale(1.05)',
                                            }
                                        },
                                        '& .color-value': {
                                            fontSize: '0.8rem',
                                            color: 'text.secondary',
                                            fontFamily: 'monospace',
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                            padding: '4px 0px',
                                            borderRadius: '4px',
                                            minWidth: '70px',
                                             width: '50%',
                                            textAlign: 'center',
                                        }
                                    }}>
                                        {/* Background Colors Section */}
                                        <div className="color-section">
                                            <div
                                                className="section-header"
                                                onClick={() => setBackgroundColorsExpanded(!backgroundColorsExpanded)}
                                            >
                                                <div className="section-title">{props.t('background_color')}</div>
                                                <IconButton size="small" className="expand-icon">
                                                    {backgroundColorsExpanded ? <ExpandLess /> : <ExpandMore />}
                                                </IconButton>
                                            </div>
                                            <Collapse in={backgroundColorsExpanded} timeout="auto">
                                                <div className="color-grid">
                                                    <div className="color-input-group">
                                                        <label htmlFor="general-header-bg-color" className="color-label">
                                                            {props.t('header_background_color')}
                                                        </label>
                                                        <input
                                                            id="general-header-bg-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.headerBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('headerBackgroundColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.headerBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('headerBackgroundColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>

                                                    <div className="color-input-group">
                                                        <label htmlFor="general-customer-header-bg-color" className="color-label">
                                                            {props.t('customer_header_background_color')}
                                                        </label>
                                                        <input
                                                            id="general-customer-header-bg-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.customerHeaderBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('customerHeaderBackgroundColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.customerHeaderBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('customerHeaderBackgroundColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>

                                                    <div className="color-input-group">
                                                        <label htmlFor="general-item-row-bg-color" className="color-label">
                                                            {props.t('item_row_background_color')}
                                                        </label>
                                                        <input
                                                            id="general-item-row-bg-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.itemRowBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('itemRowBackgroundColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.itemRowBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('itemRowBackgroundColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>

                                                    <div className="color-input-group">
                                                        <label htmlFor="general-total-bg-color" className="color-label">
                                                            {props.t('total_section_background_color')}
                                                        </label>
                                                        <input
                                                            id="general-total-bg-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.totalSectionBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('totalSectionBackgroundColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.totalSectionBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('totalSectionBackgroundColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>

                                                    <div className="color-input-group">
                                                        <label htmlFor="general-main-bg-color" className="color-label">
                                                            {props.t('main_background_color')}
                                                        </label>
                                                        <input
                                                            id="general-main-bg-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.mainBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('mainBackgroundColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.mainBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('mainBackgroundColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>

                                                    <div className="color-input-group">
                                                        <label htmlFor="general-main-bg-color" className="color-label">
                                                            {props.t('sft_background_color')}
                                                        </label>
                                                        <input
                                                            id="general-sft-bg-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.sftFooterBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('sftFooterBackgroundColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.sftFooterBackgroundColor}
                                                            onChange={(e) => handleGeneralColorChange('sftFooterBackgroundColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>
                                                </div>
                                            </Collapse>
                                        </div>

                                        {/* Text Colors Section */}
                                        <div className="color-section">
                                            <div
                                                className="section-header"
                                                onClick={() => setTextColorsExpanded(!textColorsExpanded)}
                                            >
                                                <div className="section-title">{props.t('text_color')}</div>
                                                <IconButton size="small" className="expand-icon">
                                                    {textColorsExpanded ? <ExpandLess /> : <ExpandMore />}
                                                </IconButton>
                                            </div>
                                            <Collapse in={textColorsExpanded} timeout="auto">
                                                <div className="color-grid">
                                                    <div className="color-input-group">
                                                        <label htmlFor="general-header-text-color" className="color-label">
                                                            {props.t('header_text_color')}
                                                        </label>
                                                        <input
                                                            id="general-header-text-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.headerTextColor}
                                                            onChange={(e) => handleGeneralColorChange('headerTextColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.headerTextColor}
                                                            onChange={(e) => handleGeneralColorChange('headerTextColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>

                                                    <div className="color-input-group">
                                                        <label htmlFor="general-customer-header-text-color" className="color-label">
                                                            {props.t('customer_header_text_color')}
                                                        </label>
                                                        <input
                                                            id="general-customer-header-text-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.customerHeaderTextColor}
                                                            onChange={(e) => handleGeneralColorChange('customerHeaderTextColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.customerHeaderTextColor}
                                                            onChange={(e) => handleGeneralColorChange('customerHeaderTextColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>

                                                    <div className="color-input-group">
                                                        <label htmlFor="general-item-text-color" className="color-label">
                                                            {props.t('item_text_color')}
                                                        </label>
                                                        <input
                                                            id="general-item-text-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.itemTextColor}
                                                            onChange={(e) => handleGeneralColorChange('itemTextColor', e.target.value)}
                                                        />                  
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.itemTextColor}
                                                            onChange={(e) => handleGeneralColorChange('itemTextColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>

                                                    <div className="color-input-group">
                                                        <label htmlFor="general-total-text-color" className="color-label">
                                                            {props.t('total_text_color')}
                                                        </label>
                                                        <input
                                                            id="general-total-text-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.totalTextColor}
                                                            onChange={(e) => handleGeneralColorChange('totalTextColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.totalTextColor}
                                                            onChange={(e) => handleGeneralColorChange('totalTextColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>

                                                    <div className="color-input-group">
                                                        <label htmlFor="general-total-sub-text-color" className="color-label">
                                                            {props.t('total_sub_text_color')}
                                                        </label>
                                                        <input
                                                            id="general-total-sub-text-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.totalSubTextColor}
                                                            onChange={(e) => handleGeneralColorChange('totalSubTextColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.totalSubTextColor}
                                                            onChange={(e) => handleGeneralColorChange('totalSubTextColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>

                                                    <div className="color-input-group">
                                                        <label htmlFor="general-total-sub-text-color" className="color-label">
                                                            {props.t('sft_text_color')}
                                                        </label>
                                                        <input
                                                            id="general-sft-text-color"
                                                            type="color"
                                                            className="color-input"
                                                            value={generalColors.sftFooterTextColor}
                                                            onChange={(e) => handleGeneralColorChange('sftFooterTextColor', e.target.value)}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="color-value"
                                                            value={generalColors.sftFooterTextColor}
                                                            onChange={(e) => handleGeneralColorChange('sftFooterTextColor', e.target.value)}
                                                            onBlur={(e) => {  hexChecker(e.target.value);}}
                                                            placeholder="#000000"
                                                            maxLength={7}
                                                        />
                                                    </div>
                                                </div>
                                            </Collapse>
                                        </div>
                                    </Box>
                                    {/* Color Preview */}
                                    <div style={{
                                        marginTop: '1rem',
                                        display: 'flex',
                                        height: '250px',
                                        borderLeft: `1px solid ${generalColors.borderColor}`,
                                        borderRight: `1px solid ${generalColors.borderColor}`,
                                        borderTop: `1px solid ${generalColors.borderColor}`,
                                        overflow: 'hidden'
                                    }}>
                                        {/* Left side - Receipt preview */}
                                        <div style={{
                                            width: generalStoreImageSplit ? '50%': '100%',
                                            backgroundColor: generalColors.mainBackgroundColor,
                                            borderRight: `1px solid ${generalColors.separatorColor}`,
                                            fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}>
                                            <div style={{ flex: 1 }}>
                                                <div style={{
                                                    backgroundColor: generalColors.headerBackgroundColor,
                                                    color: generalColors.headerTextColor,
                                                    padding: '0.5rem',
                                                    fontSize: '1.2rem',
                                                    fontWeight: 'bold'
                                                }}>
                                                    {customerDisplayHeaderText}
                                                </div>
                                                <div style={{
                                                    backgroundColor: generalColors.customerHeaderBackgroundColor,
                                                    color: generalColors.customerHeaderTextColor,
                                                    padding: '0.1rem 0.5rem 0.5rem 0.5rem',
                                                    fontSize: '0.9rem',
                                                    fontWeight: 'bold'
                                                }}>
                                                    John Doe (12565)
                                                </div>
                                                <div style={{
                                                    backgroundColor: generalColors.itemRowBackgroundColor,
                                                    color: generalColors.itemTextColor,
                                                    padding: '0.25rem 0.5rem',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    fontSize: '0.8rem'
                                                }}>

                                                    <span><span style={{ marginRight: '0.5rem' }}>2</span>Voorbeeld artikel</span>
                                                    <span>€ 17,91</span>
                                                </div>
                                                <div style={{
                                                    backgroundColor: generalColors.itemRowBackgroundColor,
                                                    color: generalColors.itemTextColor,
                                                    padding: '0.25rem 0.5rem 0.1rem 1.5rem',
                                                    fontSize: '0.75rem'
                                                }}>
                                                    Korting 19,90 -1,99 (10%)
                                                </div>
                                            </div>

                                            {/* Total section - always at bottom */}
                                            <div style={{
                                                backgroundColor: generalColors.totalSectionBackgroundColor,
                                                color: generalColors.totalTextColor,
                                                padding: '0.3rem 0.5rem 0 1.5rem',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                fontWeight: 'bold',
                                                fontSize: '0.9rem',
                                                marginTop: 'auto'
                                            }}>
                                                <span>Totaal</span>
                                                <span>€ 17,91</span>
                                            </div>
                                            <div style={{
                                                backgroundColor: generalColors.totalSectionBackgroundColor,
                                                color: generalColors.totalSubTextColor,
                                                padding: '0.3rem 0.5rem 0.1rem 1.5rem',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                fontWeight: 'bold',
                                                fontSize: '0.4rem',
                                                marginTop: 'auto'
                                            }}>
                                                <span>2 stuk(s)</span>
                                            </div>
                                        </div>

                                        {/* Right side - Fixed promotional content */}
                                        <div style={{
                                            width: '50%',
                                            background: 'white',
                                            color: 'grey',
                                            padding: '1rem',
                                            display: generalStoreImageSplit ? 'flex': 'none',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            textAlign: 'center'
                                        }}>
                                            <FontAwesomeIcon
                                                icon={faImage}
                                                size="3x"
                                                style={{
                                                    color: 'grey',
                                                    marginBottom: '0.5rem',
                                                    opacity: 0.8
                                                }}
                                            />
                                            <div style={{ fontSize: '0.9rem', opacity: 0.9 }}>
                                                Promotional Content
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{
                                        width: '100%',
                                        height: '10px',
                                        backgroundColor: generalColors.sftFooterBackgroundColor,
                                        color: generalColors.sftFooterTextColor,
                                        // backgroundColor: 'black',
                                        // color: 'white',
                                        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '0.5rem'
                                    }}>
                                        Powered by SoftTouch - www.softtouch.be
                                    </div>
                                </CardContent>
                            </Card>

                            <div className="flex items-center flex-1 justify-end float-right">
                                <span className="text-sm mr-2">{props.t('customer_display_normal_screen_all_stores')}</span>
                                <Switch
                                    checked={sameSettingAllStores}
                                    onChange={(e) => {
                                        setSameSettingsAllStores(!sameSettingAllStores);
                                    }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            </div>

                            {/* Store-Specific Colors Section */}
                            {(availableStores.length > 0 && !sameSettingAllStores) && (
                                <>
                                    <h3 style={{ marginBottom: '1rem' }}>{props.t('store_specific_colors')}</h3>
                                    <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: '1rem',
                                        justifyContent: 'flex-start'
                                    }}>
                                        {availableStores.map((store, index) => {
                                            const storeColorSettings = getStoreColors(store.code);
                                            const storeSettings = storeScreenTypes.find(item => item.id === store.code);
                                            const isSplitScreen = storeSettings ? storeSettings.isSplitScreen : false;

                                            return (
                                                <Card
                                                    key={index}
                                                    style={{
                                                        flexBasis: 'calc(50% - 0.5rem)',
                                                        minWidth: '450px',
                                                        marginBottom: '1rem'
                                                    }}
                                                >
                                                    <CardContent>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <Typography variant="h6" style={{ marginBottom: '1rem', width: '50%' }}>
                                                                {store.oms}
                                                            </Typography>
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '0.5rem'
                                                            }}>

                                                                <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                                                    {props.t('customer_display_split_screen')}
                                                                </Typography>
                                                                <Switch
                                                                    size="small"
                                                                    checked={storeScreenTypes.find((s) => s.id === store.code)?.isSplitScreen ?? false}
                                                                    onChange={() => handleScreenTypeChange(store.code, !isSplitScreen)}
                                                                    inputProps={{ 'aria-label': 'fullscreen toggle' }}
                                                                />
                                                            </div>
                                                        </div>
                                             

                                                        <Box sx={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 2,
                                                            position: 'relative',
                                                            '& .color-section': {
                                                                '& .section-header': {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    cursor: 'pointer',
                                                                    padding: '0.25rem 0.25rem 0.1rem 0.25rem',
                                                                    borderRadius: '6px',
                                                                    transition: 'all 0.2s ease',
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                                    }
                                                                },
                                                                '& .section-title': {
                                                                    fontSize: '0.875rem',
                                                                    fontWeight: 600,
                                                                    color: 'text.primary',
                                                                    borderBottom: '2px solid',
                                                                    borderColor: 'primary.main',
                                                                    display: 'inline-block',
                                                                    paddingBottom: '2px',
                                                                },
                                                                '& .expand-icon': {
                                                                    transition: 'transform 0.2s ease',
                                                                    color: 'primary.main',
                                                                }
                                                            },
                                                            '& .color-grid': {
                                                                display: 'grid',
                                                                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                                                gap: 1,
                                                                marginTop: 1,
                                                            },
                                                            '& .color-input-group': {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 1,
                                                                p: 0.75,
                                                                borderRadius: 1.5,
                                                                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                                                border: '1px solid rgba(0, 0, 0, 0.08)',
                                                                transition: 'all 0.2s ease',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                                    borderColor: 'rgba(0, 0, 0, 0.12)',
                                                                }
                                                            },
                                                            '& .color-label': {
                                                                minWidth: '40px',
                                                                fontSize: '0.75rem',
                                                                fontWeight: 500,
                                                                color: 'text.primary',
                                                                lineHeight: 1.2,
                                                            },
                                                            '& .color-input': {
                                                                width: '40px',
                                                                height: '34px',
                                                                border: '2px solid rgba(0, 0, 0, 0.1)',
                                                                borderRadius: '6px',
                                                                cursor: 'pointer',
                                                                transition: 'all 0.2s ease',
                                                                '&:hover': {
                                                                    borderColor: 'primary.main',
                                                                    transform: 'scale(1.05)',
                                                                }
                                                            },
                                                            '& .color-value': {
                                                                fontSize: '0.7rem',
                                                                color: 'text.secondary',
                                                                fontFamily: 'monospace',
                                                                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                                padding: '2px 6px',
                                                                borderRadius: '3px',
                                                                minWidth: '60px',
                                                                width: '50%',
                                                                textAlign: 'center',
                                                            }
                                                        }}>
                                                            {/* Background Colors Section */}
                                                            <div className="color-section">
                                                                <div
                                                                    className="section-header"
                                                                    onClick={() => setStoreBackgroundColorsExpanded(store.code, !(getStoreExpandedState(store.code)?.backgroundExpanded ?? true))}
                                                                >
                                                                    <div className="section-title">{props.t('background_color')}</div>
                                                                    <IconButton size="small" className="expand-icon">
                                                                        {(getStoreExpandedState(store.code)?.backgroundExpanded ?? true) ? <ExpandLess /> : <ExpandMore />}
                                                                    </IconButton>
                                                                </div>
                                                                <Collapse in={getStoreExpandedState(store.code)?.backgroundExpanded ?? true} timeout="auto">
                                                                    <div className="color-grid">
                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-header-bg-color`}	 className="color-label">
                                                                                {props.t('header_background_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-header-bg-color`}	
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.headerBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'headerBackgroundColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.headerBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'headerBackgroundColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>

                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-customer-header-bg-color`}	 className="color-label">
                                                                                {props.t('customer_header_background_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-customer-header-bg-color`}
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.customerHeaderBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'customerHeaderBackgroundColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.customerHeaderBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'customerHeaderBackgroundColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>

                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-item-row-bg-color`} className="color-label">
                                                                                {props.t('item_row_background_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-item-row-bg-color`}	
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.itemRowBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'itemRowBackgroundColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.itemRowBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'itemRowBackgroundColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>

                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-total-bg-color`} className="color-label">
                                                                                {props.t('total_section_background_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-total-bg-color`}
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.totalSectionBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'totalSectionBackgroundColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.totalSectionBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'totalSectionBackgroundColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>

                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-main-bg-color`} className="color-label">
                                                                                {props.t('main_background_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-main-bg-color`}
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.mainBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'mainBackgroundColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.mainBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'mainBackgroundColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>

                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-main-bg-color`} className="color-label">
                                                                                {props.t('sft_background_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-sft-bg-color`}
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.sftFooterBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'sftFooterBackgroundColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.sftFooterBackgroundColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'sftFooterBackgroundColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </Collapse>
                                                            </div>

                                                            {/* Text Colors Section */}
                                                            <div className="color-section">
                                                                <div
                                                                    className="section-header"
                                                                    onClick={() => setStoreTextColorsExpanded(store.code, !(getStoreExpandedState(store.code)?.textExpanded ?? true))}
                                                                >
                                                                    <div className="section-title">{props.t('text_color')}</div>
                                                                    <IconButton size="small" className="expand-icon">
                                                                        {(getStoreExpandedState(store.code)?.textExpanded ?? true) ? <ExpandLess /> : <ExpandMore />}
                                                                    </IconButton>
                                                                </div>
                                                                <Collapse in={getStoreExpandedState(store.code)?.textExpanded ?? true} timeout="auto">
                                                                    <div className="color-grid">
                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-header-text-color`} className="color-label">
                                                                                {props.t('header_text_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-header-text-color`}
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.headerTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'headerTextColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.headerTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'headerTextColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>

                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-customer-header-text-color`} className="color-label">
                                                                                {props.t('customer_header_text_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-customer-header-text-color`}
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.customerHeaderTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'customerHeaderTextColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.customerHeaderTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'customerHeaderTextColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>

                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-item-text-color`} className="color-label">
                                                                                {props.t('item_text_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-item-text-color`}	
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.itemTextColor}
                                                                                onChange={(e) =>  handleStoreColorChange(store.code, 'itemTextColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.itemTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'itemTextColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>

                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-total-text-color`}	 className="color-label">
                                                                                {props.t('total_text_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-total-text-color`}	
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.totalTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'totalTextColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.totalTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'totalTextColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>

                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-total-sub-text-color`} className="color-label">
                                                                                {props.t('total_sub_text_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-total-sub-text-color`}	
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.totalSubTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'totalSubTextColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.totalSubTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'totalSubTextColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>

                                                                        <div className="color-input-group">
                                                                            <label htmlFor={`store-${store.code}-total-sub-text-color`} className="color-label">
                                                                                {props.t('sft_text_color')}
                                                                            </label>
                                                                            <input
                                                                                id={`store-${store.code}-sft-text-color`}	
                                                                                type="color"
                                                                                className="color-input"
                                                                                value={storeColorSettings.sftFooterTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'sftFooterTextColor', e.target.value)}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="color-value"
                                                                                value={storeColorSettings.sftFooterTextColor}
                                                                                onChange={(e) => handleStoreColorChange(store.code, 'sftFooterTextColor', e.target.value)}
                                                                                onBlur={(e) => {  hexChecker(e.target.value);}}
                                                                                placeholder="#000000"
                                                                                maxLength={7}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </Collapse>
                                                            </div>
                                                        </Box>

                                                        {/* Store Color Preview */}
                                                        <div style={{
                                                            marginTop: '1rem',
                                                            display: 'flex',
                                                            height: '150px',
                                                            borderLeft: `1px solid ${storeColorSettings.borderColor}`,
                                                            borderRight: `1px solid ${storeColorSettings.borderColor}`,
                                                            borderTop: `1px solid ${storeColorSettings.borderColor}`,
                                                            overflow: 'hidden'
                                                        }}>
                                                            {/* Left side - Receipt preview */}
                                                            <div style={{
                                                                width: isSplitScreen ? '50%' : '100%',
                                                                backgroundColor: storeColorSettings.mainBackgroundColor,
                                                                borderRight: `1px solid ${storeColorSettings.separatorColor}`,
                                                                fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
                                                                display: 'flex',
                                                                flexDirection: 'column'
                                                            }}>
                                                                <div style={{ flex: 1 }}>
                                                                    <div style={{
                                                                        backgroundColor: storeColorSettings.headerBackgroundColor,
                                                                        color: storeColorSettings.headerTextColor,
                                                                        padding: '0.25rem',
                                                                        fontSize: '0.8rem',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                        {customerDisplayHeaderText}
                                                                    </div>
                                                                    <div style={{
                                                                        backgroundColor: storeColorSettings.customerHeaderBackgroundColor,
                                                                        color: storeColorSettings.customerHeaderTextColor,
                                                                        padding: '0.25rem',
                                                                        fontSize: '0.8rem',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                        John Doe (12565)
                                                                    </div>
                                                                    <div style={{
                                                                        backgroundColor: storeColorSettings.itemRowBackgroundColor,
                                                                        color: storeColorSettings.itemTextColor,
                                                                        padding: '0.2rem 0.25rem',
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        fontSize: '0.7rem'
                                                                    }}>
                                                                        <span>Voorbeeld artikel</span>
                                                                        <span>€ 17,91</span>
                                                                    </div>
                                                                    <div style={{
                                                                        backgroundColor: storeColorSettings.itemRowBackgroundColor,
                                                                        color: storeColorSettings.itemTextColor,
                                                                        padding: '0.15rem 0.25rem 0.1rem 1rem',
                                                                        fontSize: '0.65rem'
                                                                    }}>
                                                                        Korting 19,90 -1,99 (10%)
                                                                    </div>
                                                                </div>

                                                                {/* Total section - always at bottom */}
                                                                <div style={{
                                                                    backgroundColor: storeColorSettings.totalSectionBackgroundColor,
                                                                    color: storeColorSettings.totalTextColor,
                                                                    padding: '0.25rem 0.25rem 0rem 0.25rem',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    fontWeight: 'bold',
                                                                    fontSize: '0.7rem',
                                                                    marginTop: 'auto'
                                                                }}>
                                                                    <span>Totaal</span>
                                                                    <span>€ 17,91</span>
                                                                </div>
                                                                <div style={{
                                                                    backgroundColor: storeColorSettings.totalSectionBackgroundColor,
                                                                    color: storeColorSettings.totalSubTextColor,
                                                                    padding: '0.25rem 0.25rem 0.1rem 1rem',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    fontWeight: 'bold',
                                                                    fontSize: '0.5rem',
                                                                    marginTop: 'auto'
                                                                }}>
                                                                    <span>2 stuk(s)</span>
                                                                </div>
                                                            </div>

                                                            {/* Right side - Fixed promotional content */}
                                                            <div style={{
                                                                width: '50%',
                                                                background: 'white',
                                                                color: 'grey',
                                                                padding: '0.5rem',
                                                                display: isSplitScreen ? 'flex' : 'none',
                                                                flexDirection: 'column',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                textAlign: 'center'
                                                            }}>
                                                                <FontAwesomeIcon
                                                                    icon={faImage}
                                                                    size="lg"
                                                                    style={{
                                                                        color: 'grey',
                                                                        marginBottom: '0.25rem',
                                                                        opacity: 0.8
                                                                    }}
                                                                />
                                                                <div style={{ fontSize: '0.65rem', opacity: 0.9 }}>
                                                                    Promotional Content
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style={{
                                                            width: '100%',
                                                            height: '8px',
                                                            backgroundColor: 'black',
                                                            color: 'white',
                                                            fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '0.45rem'
                                                        }}>
                                                            Powered by SoftTouch - www.softtouch.be
                                                        </div>
                                                    </CardContent>
                                                </Card>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </div>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <div className='columnContainerStart _100perc'>

                            <hr />
                            <TextField
                                autoComplete="off"
                                className={props.theme + "_accent " + props.theme + "_text _100perc"}
                                style={{ margin: "0.3rem" }}
                                id="customer_display_url"
                                label={props.t('customer_display_url')}
                                sx={(props.theme === 'light') ? {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.light_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.light_text
                                    }
                                }
                                    :
                                    {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.dark_text_accent
                                        }
                                    }}
                                value={ftp.url}
                                onChange={(event) => { handleFtpEdit(event.target.value, "url") }}
                            />
                            <TextField
                                autoComplete="off"
                                className={props.theme + "_accent " + props.theme + "_text _100perc"}
                                style={{ margin: "0.3rem" }}
                                id="customer_display_url"
                                label={props.t('customer_display_path')}
                                sx={(props.theme === 'light') ? {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.light_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.light_text
                                    }
                                }
                                    :
                                    {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.dark_text_accent
                                        }
                                    }}
                                value={ftp.path}
                                onChange={(event) => { handleFtpEdit(event.target.value, "path") }}
                            />
                            <TextField
                                autoComplete="off"
                                className={props.theme + "_accent " + props.theme + "_text _100perc"}
                                style={{ margin: "0.3rem" }}
                                id="customer_display_ftp_host"
                                label={props.t('customer_display_ftp_host')}
                                sx={(props.theme === 'light') ? {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.light_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.light_text
                                    }
                                }
                                    :
                                    {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.dark_text_accent
                                        }
                                    }}
                                value={ftp.host}
                                onChange={(event) => { handleFtpEdit(event.target.value, "host") }}
                            />
                            <TextField
                                autoComplete="off"
                                className={props.theme + "_accent " + props.theme + "_text _100perc"}
                                style={{ margin: "0.3rem" }}
                                id="customer_display_ftp_user"
                                label={props.t('customer_display_ftp_user')}
                                sx={(props.theme === 'light') ? {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.light_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.light_text
                                    }
                                }
                                    :
                                    {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.dark_text_accent
                                        }
                                    }}
                                value={ftp.username}
                                onChange={(event) => { handleFtpEdit(event.target.value, "username") }}
                            />
                            <TextField
                                autoComplete="off"
                                className={props.theme + "_accent " + props.theme + "_text _100perc"}
                                style={{ margin: "0.3rem" }}
                                id="customer_display_ftp_pass"
                                label={props.t('customer_display_ftp_pass')}
                                sx={(props.theme === 'light') ? {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.light_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.light_text
                                    }
                                }
                                    :
                                    {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.dark_text_accent
                                        }
                                    }}
                                value={ftp.password}
                                onChange={(event) => { handleFtpEdit(event.target.value, "password") }}
                            />
                            <TextField
                                autoComplete="off"
                                className={props.theme + "_accent " + props.theme + "_text _100perc"}
                                style={{ margin: "0.3rem" }}
                                id="customer_display_ftp_port"
                                label={props.t('customer_display_ftp_port')}
                                sx={(props.theme === 'light') ? {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.light_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.light_text
                                    }
                                }
                                    :
                                    {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.dark_text_accent
                                        }
                                    }}
                                value={ftp.port}
                                onChange={(event) => { handleFtpEdit(event.target.value, "port") }}
                            />
                            <TextField
                                autoComplete="off"
                                className={props.theme + "_accent " + props.theme + "_text _100perc"}
                                style={{ margin: "0.3rem" }}
                                id="customer_display_default_duration"
                                label={props.t('customer_display_default_duration')}
                                sx={(props.theme === 'light') ? {
                                    '& .MuiOutlinedInput-input': {
                                        color: Colors.light_text
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: Colors.light_text
                                    }
                                }
                                    :
                                    {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.dark_text_accent
                                        }
                                    }}
                                value={defaultDuration}
                                onChange={(event) => { setDefaultDuration(event.target.value) }}
                            />

                        </div>
                    </TabPanel>
                </Box>}
                {(dbVersion < 316 && !loading) && <p className='error_text'>Database update required.	&#40;current: {dbVersion}, required: 316&#41;</p>}
            </div>
            {(dbVersion >= 316 && !loading && value === 0) ? <FloatingAddButton disabled={loading} onClick={() => { createRow() }} /> : <div></div>}
            {(dbVersion >= 316 && !loading && value !== 0) ? <FloatingSaveButton disabled={loading} onClick={()=>{  handleSaveSettings(value) }} /> : <div></div>}
        </div>
    );
}

export default CustomerDisplayScreen;